enum RichIconTypes {
    AMBULANSE = 'ambulanse',
    ATV = 'atv',
    AVTALEGIRO_1 = 'avtalegiro-1',
    BAAT_M_HIMMEL = 'baat-m-himmel',
    BAAT_M_SOL = 'baat-m-sol',
    BAAT = 'baat',
    BAEREKRAFT_KORTREIST = 'baerekraft-kortreist',
    BAGASJE_FLYPLASS = 'bagasje-flyplass',
    BAGASJE = 'bagasje',
    BAGASJE_LYSE_LINJER = 'bagasje-lyse-linjer',
    BAMSE_BARNEFORSIKRING = 'bamse-barneforsikring',
    BANK_ID_KODEBRIKKE = 'bank-id-kodebrikke',
    BANKBYGG = 'bankbygg',
    BANKKORT_BARN_UNGE = 'bankkort-barn-unge',
    BARN = 'barn',
    BEDRIFT_BYGNING = 'bedrift-bygning',
    BEDRIFT_KONTOR = 'bedrift-kontor',
    BIL = 'bil-1',
    BIL_ENKEL = 'bil-enkel',
    BIL_M_SKYER = 'bil-m-skyer',
    BIL_SKADET_1 = 'bil-skadet-1',
    BIL_SKADET_2 = 'bil-skadet-2',
    BIL_SKADET_LYSE_LINJER = 'bil-skadet-lyse-linjer-1',
    BIL_TAKBOKS = 'bil-takboks-1',
    BIL_TAKBOKS_SKADET = 'bil-takboks-skadet-1',
    BIL_TAKBOKS_SKADET_LYSE_LINJER = 'bil-takboks-skadet-lyse-linjer-1',
    BJELLE_RINGER = 'bjelle-ringer',
    BOBIL = 'bobil',
    BOLIGLAAN = 'boliglaan',
    BONDEGAARD_HUS = 'bondegaard-hus',
    BONDEGAARD_SILO = 'bondegaard-silo',
    BSU = 'bsu',
    BUTIKKLOKALE_1 = 'butikklokale-1',
    BUTIKKLOKALE_2 = 'butikklokale-2',
    BYGGELAAN = 'byggelaan',
    CAMPINGVOGN = 'campingvogn',
    CHATBOT_A = 'chatbot-A',
    CHATBOT_B = 'chatbot-B',
    DARTSKIVE = 'dartskive',
    DATAFEIL_1 = 'datafeil-1',
    DATAFEIL_2 = 'datafeil-2',
    DATAFEIL_3 = 'datafeil-3',
    DEFAULTIKON = 'defaultikon',
    DIGITALTKORT_ABONNEMENT = 'digitaltkort-abonnement',
    DIGITALTKORT_KLOKKE = 'digitaltkort-klokke',
    DIGITALTKORT_MOBIL = 'digitaltkort-mobil',
    DRONE = 'drone',
    DUE_DOEDSFALL = 'due-doedsfall',
    EFAKTURA_1 = 'efaktura-1',
    EGENKAPITAL = 'egenkapital',
    EIKA_PLUSS = 'eika-pluss',
    EL_SKATEBOARD = 'el-skateboard',
    EL_SPARKESYKKEL = 'el-sparkesykkel',
    ELBIL = 'elbil',
    ENHJULING = 'enhjuling',
    FAMILIE_I_HJERTERAMME = 'familie-i-hjerteramme',
    FAMILIE_I_RAMME = 'familie-i-ramme',
    FAMILIE = 'familie',
    FANGER_SOMMERFUGLER = 'fanger-sommerfugler',
    FINANSIERINGSBEVIS = 'finansieringsbevis',
    FJELLKLATRING_TEAMWORK = 'fjellklatring-teamwork',
    FONDSSPARING_NORGE = 'fondssparing-norge',
    FONDSSPARING_SPAREPARTNER = 'fondssparing-sparepartner',
    FORELDREKONTROLL_OEKONOMISK_VEILEDER_KUNNSKAP = 'foreldrekontroll-oekonomisk-veileder-kunnskap',
    FOTBALLDRAKT_EIKA = 'fotballdrakt-eika',
    GAARDSBIL = 'gaardsbil',
    GAVEKORT = 'gavekort',
    GAVER = 'gaver',
    GI_GAVE = 'gi-gave',
    GRAVEMASKIN = 'gravemaskin',
    GRUPPE_MENNESKER = 'gruppe-mennesker',
    GRUPPE = 'gruppe',
    HAAND_HEIHEI = 'haand-heihei',
    HAANDVERKERBIL = 'haandverkerbil',
    HACKER = 'hacker',
    HAND_M_DIAMANT = 'hand-m-diamant',
    HAV_SMAA_BOELGER = 'hav-smaa-boelger',
    HAV_STORE_BOELGER = 'hav-store-boelger',
    HENDER_SAMHOLD = 'hender-samhold',
    HENGEKOYE = 'hengekoye',
    HEST = 'hest',
    HJERTE_M_HENDER = 'hjerte-m-hender',
    HJERTE_M_PLASTER = 'hjerte-m-plaster',
    HJERTE_GLINSER = 'hjerte-glinser',
    HJERTE = 'hjerte-enkelt',
    HODETELEFONER = 'hodetelefoner',
    HONE = 'hone',
    HUND = 'hund',
    HUS_ENKELT = 'hus-enkelt',
    HUS_M_BIL = 'hus-m-bil',
    HUS_M_SKYER = 'hus-m-skyer',
    HYTTE = 'hytte',
    INNBO = 'innbo',
    INNTEKT_FLYTT = 'inntekt-flytt',
    JORDKLODE = 'jordklode',
    KALKULATOR = 'kalkulator',
    KART_NORDEN = 'kart-norden',
    KATT = 'katt',
    KLOKKE = 'klokke',
    KODELAS_1 = 'kodelas-1',
    KODELAS_2 = 'kodelas-2',
    KONTAKTINFO = 'kontaktinfo',
    KORNAAKER = 'kornaaker',
    KREDITTKORT = 'kredittkort',
    KRITISK_SYKDOM_SYKESENG = 'kritisk-sykdom-sykeseng',
    KRITISK_SYKDOM = 'kritisk-sykdom',
    KRYKKER = 'krykker',
    KU = 'ku',
    KULERAMME = 'kuleramme',
    KUNDESERVICE_1 = 'kundeservice-1',
    LANDBRUKSMASKIN = 'landbruksmaskin',
    LANDSKAP = 'landskap',
    LASTEBIL = 'lastebil',
    LOMMEBOK_INNTEKT = 'lommebok-inntekt',
    LOMMEBOK = 'lommebok',
    LYSPARE_BLOMST = 'lyspare-blomst',
    LYSPARE = 'lyspare',
    MOBILBANK_APP_KUN_TELEFON = 'mobilbank-app-kun-telefon',
    MOBILBANK_APP_LOGO = 'mobilbank-app-logo',
    MOBILBANK_SPAREGRIS = 'mobilbank-sparegris',
    MOTORSYKKEL = 'motorsykkel',
    NAERINGSBIL = 'naeringsbil',
    NESTE_LOENNING = 'neste-loenning',
    NESTE_LOENNING_1 = 'neste-loenning-1',
    NETTBANK_MOBILBANK = 'nettbank-mobilbank',
    NETTVERKSBRUDD_2 = 'nettverksbrudd-2',
    NETTVERKSBRUDD_HARE = 'nettverksbrudd-hare',
    NORDEN = 'norden',
    ONLINE_MOETEBOOKING_ALT1 = 'online-moetebooking-alt1',
    ONLINE_MOETEBOOKING_ALT1_1 = 'online-moetebooking-alt1-1',
    ONLINE_MOETEBOOKING_ALT2 = 'online-moetebooking-alt2',
    ONLINE_MOETEBOOKING_ALT2_1 = 'online-moetebooking-alt2-1',
    ONLINE = 'online',
    OPPMUNTRENDE = 'oppmuntrende',
    OVERBLIKK = 'overblikk',
    PARK_M_FUGL = 'park-m-fugl',
    PARK = 'park',
    PENGESEKK_REFINANSIERING = 'pengesekk-refinansiering',
    PENGESEKK = 'pengesekk',
    PLASTER = 'plaster',
    POSTKORT = 'postkort',
    PUSLESPILL_TEAMWORK = 'puslespill-teamwork',
    RAADGIVER = 'raadgiver',
    REGNING_M_KAFFEKOPP = 'regning-m-kaffekopp',
    RELEGITIMERING = 'relegitimering',
    SAMTYKKE = 'samtykke',
    SCOOTER = 'scooter',
    SEILBAAT_SKADET = 'seilbaat-skadet',
    SEILBAAT = 'seilbaat',
    SELVBALANSEREDE_BRETT = 'selvbalanserede-brett',
    SIGNERING = 'signering',
    SKATTEKART = 'skattekart',
    SKATTEKISTE = 'skattekiste',
    SNAKKEBOBLER = 'snakkebobler',
    SNOESCOOTER = 'snoescooter',
    SOLSENG = 'solseng',
    SOMMERFUGLER_2 = 'sommerfugler-2',
    SOMMERFUGLER = 'sommerfugler',
    SPAREAVTALE = 'spareavtale',
    SPAREGRIS = 'sparegris',
    SPARING_GRADVIS_OEKNING = 'sparing-gradvis-oekning',
    SPARING_SCOOTER = 'sparing-scooter',
    SPARING_SPARKESYKKEL = 'sparing-sparkesykkel',
    SPERR_KORT_MIDLERTIDIG = 'sperr-kort-midlertidig',
    SPERR_KORT_PERMANENT = 'sperr-kort-permanent',
    SPIRE = 'spire',
    SPORTSUTSTYR = 'sportsutstyr',
    STAAHJULING = 'staahjuling',
    STANDARISERING_DIPLOM = 'standarisering-diplom',
    STANDARISERING = 'standarisering',
    STOPPEKLOKKE = 'stoppeklokke',
    STOPPEKLOKKE_1 = 'stoppeklokke-1',
    STYRINGSRENTE_MATCH = 'styringsrente-match',
    STORK_M_GAVE = 'stork-m-gave',
    STORT_HUS = 'stort-hus',
    STRAND_M_PALME = 'strand-m-palme',
    TALMODIG = 'talmodig',
    TAXI = 'taxi',
    TAXI_1 = 'taxi-1',
    TELEFON_OG_KAFFE = 'telefon-og-kaffe',
    TILBUDSBREV = 'tilbudsbrev-1',
    TILHENGER = 'tilhenger',
    TRAFIKKLYS_GROENT = 'trafikklys-groent-1',
    TRAFIKKLYS_GULT = 'trafikklys-gult-1',
    TRAFIKKLYS_ROEDT = 'trafikklys-roedt-1',
    TRAKTOR = 'traktor',
    TRILLEBAAR = 'trillebaar',
    TYV = 'tyv',
    UFOEREFORSIKRING = 'ufoereforsikring',
    ULYKKE_STIGE = 'ulykke-stige',
    ULYKKE = 'ulykke',
    UNDRENDE = 'undrende',
    UNG = 'ung',
    VARETRANSPORT = 'varetransport',
    VEKT_HOY_RISIKO = 'vekt-hoy-risiko',
    VEKT_HOYRE = 'vekt-hoyre',
    VEKT_LAV_RISIKO = 'vekt-lav-risiko',
    VEKT_LIKEVEKT = 'vekt-likevekt',
    VEKT_MIDDELS_RISIKO = 'vekt-middels-risiko',
    VEKT_VENSTRE = 'vekt-venstre',
    VERDIGJENSTAND = 'verdigjenstand',
    VERKTOEYKASSE = 'verktoeykasse',
    VETERANKJOERETOEY = 'veterankjoeretoey',
    VIPPS = 'vipps',
}

export default RichIconTypes;
